// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalImages_modal__arrow__r6kzj {
	cursor: pointer;
	height: 100%;
	width: 3rem;
	-webkit-user-select: none;
	        user-select: none;
}

.ModalImages_modal__img__NBdQR {
	width: 72rem;
	height: 42rem;
	max-width: calc(100vw - 12rem);
	max-height: calc(100vh - 4rem);
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border-radius: 0.5rem;
	overflow: hidden;
}

.ModalImages_modal__img__NBdQR img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.ModalImages_modal__body__akP0u {
	display: flex;
	align-items: center;
	justify-content: space-around;
}

.ModalImages_close__button__UWPi0 path {
	fill: var(--accent-color);
}

@media (max-width: 1280px) {
	.ModalImages_modal__img__NBdQR {
		width: 58rem;
		height: 34rem;
		max-width: calc(100vw - 8rem);
	}
}

@media (max-width: 900px) {
	.ModalImages_modal__img__NBdQR {
		width: calc(100vw - 6rem);
		height: calc(100vh - 12rem);
		max-width: none;
		max-height: none;
	}
}

@media (max-width: 460px) {
	.ModalImages_modal__body__akP0u {
		justify-content: space-between;
	}
	.ModalImages_modal__img__NBdQR {
		width: calc(100vw - 4.5rem);
		height: calc(100vh - 10rem);
	}
	.ModalImages_modal__body__akP0u {
		justify-content: space-between;
		padding: 0.5rem;
		padding-inline-start: none;
		padding-inline-end: none;
	}
	.ModalImages_modal__arrow__r6kzj {
		width: 3rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/ModalImages/ModalImages.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,8BAA8B;CAC9B,8BAA8B;CAC9B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;EACb,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,8BAA8B;CAC/B;CACA;EACC,2BAA2B;EAC3B,2BAA2B;CAC5B;CACA;EACC,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;CACzB;CACA;EACC,WAAW;CACZ;AACD","sourcesContent":[".modal__arrow {\n\tcursor: pointer;\n\theight: 100%;\n\twidth: 3rem;\n\tuser-select: none;\n}\n\n.modal__img {\n\twidth: 72rem;\n\theight: 42rem;\n\tmax-width: calc(100vw - 12rem);\n\tmax-height: calc(100vh - 4rem);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: #fff;\n\tborder-radius: 0.5rem;\n\toverflow: hidden;\n}\n\n.modal__img img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n}\n\n.modal__body {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n}\n\n.close__button path {\n\tfill: var(--accent-color);\n}\n\n@media (max-width: 1280px) {\n\t.modal__img {\n\t\twidth: 58rem;\n\t\theight: 34rem;\n\t\tmax-width: calc(100vw - 8rem);\n\t}\n}\n\n@media (max-width: 900px) {\n\t.modal__img {\n\t\twidth: calc(100vw - 6rem);\n\t\theight: calc(100vh - 12rem);\n\t\tmax-width: none;\n\t\tmax-height: none;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.modal__body {\n\t\tjustify-content: space-between;\n\t}\n\t.modal__img {\n\t\twidth: calc(100vw - 4.5rem);\n\t\theight: calc(100vh - 10rem);\n\t}\n\t.modal__body {\n\t\tjustify-content: space-between;\n\t\tpadding: 0.5rem;\n\t\tpadding-inline-start: none;\n\t\tpadding-inline-end: none;\n\t}\n\t.modal__arrow {\n\t\twidth: 3rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__arrow": `ModalImages_modal__arrow__r6kzj`,
	"modal__img": `ModalImages_modal__img__NBdQR`,
	"modal__body": `ModalImages_modal__body__akP0u`,
	"close__button": `ModalImages_close__button__UWPi0`
};
export default ___CSS_LOADER_EXPORT___;
